import * as React from "react"
import type { SVGProps } from "react"
const SvgUserFile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 14.57q.81 0 1.4-.59.6-.59.6-1.4 0-.84-.6-1.42a2 2 0 0 0-1.4-.59q-.84 0-1.42.59a2 2 0 0 0-.59 1.41q0 .82.59 1.41.6.6 1.41.6m4 4V18a2 2 0 0 0-1.23-1.85 8 8 0 0 0-1.34-.43 7 7 0 0 0-2.87 0q-.69.15-1.34.43A2 2 0 0 0 7.99 18v.57z" />
    <path
      fillRule="evenodd"
      d="M4.59 21.98q.59.6 1.41.6h12q.83 0 1.41-.6.6-.59.59-1.4V9.4a2 2 0 0 0-.57-1.4l-4.85-4.85a2 2 0 0 0-1.4-.58H6q-.82 0-1.41.59A2 2 0 0 0 4 4.57v16q0 .82.59 1.41M13 4.57v4q0 .42.29.71.29.3.71.29h4v11H6v-16z"
    />
  </svg>
)
export default SvgUserFile
